import { createUseStyles } from 'react-jss';
import { ITheme } from '../theme';

type RuleNames =
  | 'date'
  | 'message'
  | 'messagesBlock'
  | 'messageBlock'
  | 'emptyBlock'
  | 'time'
  | 'imgBlock'
  | 'imgMainBlock'
  | 'imgMessageBlock';

const PREFIX = 'Conversation';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      date: {
        marginTop: 16,
        textAlign: 'center',
        opacity: '0.6',
        color: theme.darkGreen,
        fontSize: '18px',
        fontWeight: 400,
      },
      imgMessageBlock: {
        position: 'fixed',
        margin: '26px 110px',
      },
      imgMainBlock: {
        position: 'relative',
        top: 26,
      },
      imgBlock: {
        display: 'flex',
        opacity: '0.1',
      },
      message: {
        marginTop: 16,
        padding: '14px 17px 14px 30px',
        textAlign: 'left',
        width: '85.8%',
        fontFamily: theme.helveticaNeue,
        color: theme.darkGreen,
        fontSize: '14px',
        fontWeight: 400,
        background: '#FFFFFF',
        borderRadius: 5,
        zIndex: '99999999',
      },
      messagesBlock: {
        height: 'calc(100% - 4rem)',
        width: '100%',
        overflowY: 'scroll',
      },
      messageBlock: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        alignItems: 'center',
      },
      emptyBlock: {
        textAlign: 'center',
        color: theme.darkBlack,
        fontSize: '18px',
        fontWeight: 400,
        '& .MuiTypography-root': {
          position: 'relative',
          bottom: 280,
          left: 107,
          color: '#3B5D3E',
          fontFamily: theme.caslonDoric,
          fontSize: 16,
          maxWidth: '230px',
        },
      },
      time: {
        alignSelf: 'flex-end',
        color: '#6CA370',
        fontSize: '14px',
        fontWeight: 400,
        margin: '8px 22px 0 0',
      },
    }
  ),
  { name: PREFIX },
);
